import CancelIcon from '@mui/icons-material/CancelOutlined';
import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';

type FormActionsMuiCancelActionProps = {
  disabled: boolean;
  onCancel: () => void;
};

/** Secondary cancel button that navigates away or invokes a custom handler. */
export function FormActionsMuiCancelAction({
  disabled,
  onCancel,
}: FormActionsMuiCancelActionProps) {
  return (
    <Button color="secondary" startIcon={<CancelIcon />} onClick={onCancel} disabled={disabled}>
      <FormattedMessage id="common.cancel" defaultMessage="Cancelar" />
    </Button>
  );
}
